import PropTypes from 'prop-types';
import React from 'react';
import Icon from './../Icon';
import useInputRadio from './useInputRadio';

const InputRadio = ({ onChange, label, value, name, checked, disabled, description, checkedIcon, uncheckedIcon }) => {
  const { animation, handleClick, handleKeyDown, animationEnd } = useInputRadio({ onChange, checked, value, disabled });

  return (
    <label
      className={`input-radio ${disabled ? 'input-radio--disabled' : ''} ${checked ? 'input-radio--checked' : 'input-radio--unchecked'}`}
      data-animation={animation}
      onAnimationEnd={animationEnd}
    >
      <input
        aria-checked={checked}
        checked={checked}
        className={`input-radio__input`}
        disabled={disabled}
        name={name}
        onChange={handleClick}
        onKeyDown={handleKeyDown}
        type="radio"
        value={value}
      />
      <div className={`input-radio__icon-container input-radio__icon-container--${checked ? 'checked' : 'unchecked'} `}>
        <Icon type={checked ? checkedIcon : uncheckedIcon} color={checked ? 'primary' : 'default'} aria-hidden="true" />
      </div>
      <div className="input-radio__texts">
        <span className={`input-radio__label ${description === '' ? 'input-radio__label--no-description' : ''}`}>{label}</span>
        {description && <span className="input-radio__description">{description}</span>}
      </div>
    </label>
  );
};

InputRadio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  checkedIcon: PropTypes.string,
  uncheckedIcon: PropTypes.string,
};

InputRadio.defaultProps = {
  checkedIcon: 'check-checked-round',
  uncheckedIcon: 'check-unchecked-round',
  description: '',
  label: '',
  onChange: () => {},
  checked: false,
  disabled: false,
};

export default InputRadio;
